import type { ComponentProps } from 'react';

import { cn } from './utils';

/**
 * A loading placeholder. `motion-reduce:animate-none` is not optional — the
 * dashboard's card skeletons carry it and this is the same pulse.
 *
 * Shape it like the answer: a skeleton the same height as the real row is what
 * stops the page shifting when data lands (dashboard-page.tsx does exactly
 * this for its grid).
 */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-pill bg-hairline motion-reduce:animate-none',
        className,
      )}
      data-slot="skeleton"
      {...props}
    />
  );
}
